import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";

import { PractitionerService } from "../shared/services/practitioner.service";
import { ViewStateService } from "../../shared/services/view-state.service";
import { UserService } from "./../../shared/services/user.service";
import { NotificationsService } from "./../../shared/services/notifications.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-purchase-detail",
  templateUrl: "./purchase-detail.component.html",
})
export class PurchaseDetailComponent implements OnInit, OnDestroy {
  personId: string;
  purchaseDetail: any;
  private purchaseId: string;
  getEmail = false;
  private destroy$ = new Subject<void>();

  constructor(
    private viewState: ViewStateService,
    private practitionerService: PractitionerService,
    private route: ActivatedRoute,
    private userService: UserService,
    private notification: NotificationsService
  ) {}

  ngOnInit() {
    this.viewState.startLoading();
    this.personId = this.userService.CurrentUser.personId;
    this.purchaseId = this.route.snapshot.params["id"];

    this.practitionerService
      .getPurchaseDetail(this.purchaseId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (details) => {
          this.purchaseDetail = details;
          this.viewState.stopLoading();
        },
        (error) => {
          console.error(error);
          this.viewState.stopLoading();
        }
      );
  }

  printPurchaseDetail() {
    window.print();
  }

  get paymentMethodLabel(): string {
    if (this.purchaseDetail) {
      //this will get checked before the details load and again after.  skip if it's not populated
      if (this.purchaseDetail.paymentMethod === "V") {
        return "Voucher";
      }
      if (this.purchaseDetail.paymentMethod === "CP") {
        return "No Payment Required";
      }
      if (this.purchaseDetail.paymentMethod === "CH") {
        return "Check";
      }
      if (this.purchaseDetail.paymentMethod === "CC") {
        return "Credit Card";
      }
      if (this.purchaseDetail.paymentMethod === "ACH") {
        return "E-Check";
      }
      return this.purchaseDetail.paymentMethod;
    }
  }

  emailPurchaseDetail() {
    this.viewState.startLoading();
    const email = this.userService.CurrentUser.email;
    this.practitionerService
      .getEmailPurchaseDetail(this.purchaseId, email)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.viewState.stopLoading();
          this.notification.success(
            "Success",
            "Receipt emailed to address on file."
          );
        },
        (error) => {
          console.error(error);
          this.viewState.stopLoading();
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
